import React from "react";
import "./style.scss";

export const getUserNickname = (user, nicknameFormat = '{surname} {name} {patronymic}') => {
    if (!user) {
        return null;
    }
    if (user?.nickname) {
        return user.nickname;
    }
    if (user?.info?.nickname) {
        return user.info.nickname;
    }

    return nicknameFormat
            .replace(/{([-_\w]+)}/gi, (m, name) => user[name] || (user.info && user.info[name]) || '')
            .trim()
        || `Зритель №${user.id}`
    ;
}

export const UserNickname = ({user, nicknameFormat, ...props}) => {
    const className = 'user-nickname';
    const name = user ? getUserNickname(user, nicknameFormat) : 'Аноним';

    if (!user) {
        return (
            <div className={`${className} ${className}-anonymous`} {...props}>{name}</div>
        );
    }
}

export const UserAvatar = ({user, size = null, initials, photo, ...props}) => {
    let text = '';
    let avatar = user?.avatar || user?.info?.avatar || null;
    let nickname = user?.nickname || user?.info?.nickname || '';

    let className = 'user-avatar';
    if ('small' === size || 'large' === size || 'medium' === size || 'xx-large' === size) {
        className += ' ' + size;
    }
    if (props.onClick) {
        className += ` ${className}-link`;
    }

    if (avatar || photo) {
        return (
            <span className={className} style={{backgroundImage: `url(${photo || avatar})`}} title={nickname} {...props} />
        );
    }

    if (initials) {
        text = initials;
    } else if (nickname) {
        text = nickname.substring(0, 1);
    } else {
        let name = user?.name || user?.info?.name || '';
        let surname = user?.surname || user?.info?.surname || '';
        text = surname.substring(0, 1) + name.substring(0, 1);
    }

    if (text) {
        return (
            <span className={className} title={nickname} {...props}>{text}</span>
        );
    }

    return (
        <span className={className} title={nickname} {...props}>
            <svg width="100%" height="100%" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <path className="avatar-body" fill="#fff" stroke="none" strokeWidth="0.3" d="M4,64 C7,39 14,39 32,39 S57,39 60,64" />
                <path className="avatar-head" strokeWidth="4px" stroke="#ccc" fill="#fff" d="M32,13 C54,13 46,43 32,44 C20,43 8,13 32,13 Z" />
            </svg>
        </span>
    );
}
